import { render, staticRenderFns } from "./categoryContent.vue?vue&type=template&id=9323ce16&scoped=true&"
import script from "./categoryContent.vue?vue&type=script&lang=js&"
export * from "./categoryContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9323ce16",
  null
  
)

export default component.exports